import type { Booking } from "@/types/domain";

export const bookingResponseDeadline = (booking: Pick<Booking, "expiresAt" | "ownerResponseDeadline">) =>
  new Date(booking.expiresAt ?? booking.ownerResponseDeadline ?? 0).getTime();

export const isBookingResponseWindowOpen = (booking: Pick<Booking, "expiresAt" | "ownerResponseDeadline">, now = Date.now()) =>
  bookingResponseDeadline(booking) > now;
